
const messages = {
    en: {
       role: {
            permissions: {
                PEDIDOCUENTA_MENU: "Access to PedidoCuenta",
                PEDIDOCUENTA_SHOW: "View PedidoCuenta",
                PEDIDOCUENTA_MY_SHOW: "View my PedidoCuenta",
                PEDIDOCUENTA_CREATE: "Create PedidoCuenta",
                PEDIDOCUENTA_UPDATE: "Modify PedidoCuenta",
                PEDIDOCUENTA_MY_UPDATE: "Modify my PedidoCuenta",
                PEDIDOCUENTA_MY_ESTADO_UPDATE: "Modify my PedidoCuenta status",
                PEDIDOCUENTA_DELETE: "Delete PedidoCuenta",
            }
       }
    },
    es: {
        role: {
            permissions: {
                PEDIDOCUENTA_MENU: "Acceder PedidoCuenta",
                PEDIDOCUENTA_SHOW: "Ver PedidoCuenta",
                PEDIDOCUENTA_MY_SHOW: "Ver mis PedidoCuenta",
                PEDIDOCUENTA_CREATE: "Crear PedidoCuenta",
                PEDIDOCUENTA_UPDATE: "Modificar PedidoCuenta",
                PEDIDOCUENTA_MY_UPDATE: "Modificar mis PedidoCuenta",
                PEDIDOCUENTA_MY_ESTADO_UPDATE: "Modificar estado de mis PedidoCuenta",
                PEDIDOCUENTA_DELETE: "Eliminar PedidoCuenta",
            }
       }
    },
    pt: {
       role: {
            permissions: {
                PEDIDOCUENTA_MENU: "Acessar PedidoCuenta",
                PEDIDOCUENTA_SHOW: "Ver PedidoCuenta",
                PEDIDOCUENTA_MY_SHOW: "Ver meus PedidoCuenta",
                PEDIDOCUENTA_CREATE: "Criar PedidoCuenta",
                PEDIDOCUENTA_UPDATE: "Modificar PedidoCuenta",
                PEDIDOCUENTA_MY_UPDATE: "Modificar meus PedidoCuenta",
                PEDIDOCUENTA_MY_ESTADO_UPDATE: "Modificar estado dos meus PedidoCuenta",
                PEDIDOCUENTA_DELETE: "Eliminar PedidoCuenta",
            }
       }
    }
}

export default messages
    
